import { Skeleton } from '@mui/material';

export function DeferredSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} variant="rectangular" height={48} />
      ))}
    </div>
  );
}
